import { render } from "./PrimaryFooter.vue?vue&type=template&id=5a586342"
import script from "./PrimaryFooter.vue?vue&type=script&lang=js"
export * from "./PrimaryFooter.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__